import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {required} from "../../../../../../shared/utils";
import {
    ContactTypes
} from "../../../../template/contact-dropdown-button/contact-dropdown-button.component";
import {ContactSendingFormNode} from "../../../node-delegator/nodes/menu/contact-sending/contactSending";
import cloneDeep from 'lodash/cloneDeep';
import {DeleteContact} from "../../../../template/contacts-template/contacts-template.component";
import {Contact} from "../../translator/outbound-translator";

@Component({
    selector: 'send-contact-card',
    templateUrl: './send-contact-card.component.html',
    styleUrls: ['./send-contact-card.component.scss']
})
export class SendContactCardComponent implements OnInit {

    @Output() close: EventEmitter<any> = new EventEmitter();
    @Output() send: EventEmitter<Contact> = new EventEmitter();

    contactInfo: FormGroup;
    contactInfoRawData = {}

    constructor(private fb: FormBuilder) {
    }

    ngOnInit(): void {
        this.contactInfo = this.fb.group({
            addresses: new FormArray([]),
            emails: new FormArray([]),
            org: new FormArray([]),
            phones: new FormArray([]),
            urls: new FormArray([]),
            birthdays: new FormArray([]),
            firstName: new FormControl('', [required('first name')]),
            lastName: new FormControl('', [required('last name')]),
            formattedName: new FormControl('', [required('formatted name')]),
        });

        this.contactInfoRawData = this.contactInfo.getRawValue()
    }

    closeSendContact() {
        this.close.emit();
    }

    addContact(contact: ContactTypes) {
        let newContact = undefined;
        const canEdit = {
            canEditFlows: true,
            canEditMenuTextOnly: true,
            canEdit: true,
        }
        switch (contact) {
            case ContactTypes.ADDRESS:
                newContact = ContactSendingFormNode.getAddressTemplate(canEdit);
                break
            case ContactTypes.BIRTHDAY:
                newContact = ContactSendingFormNode.getBirthdayTemplate(canEdit);
                break
            case ContactTypes.EMAIL:
                newContact = ContactSendingFormNode.getEmailTemplate(canEdit);
                break
            case ContactTypes.ORGANISATION:
                newContact = ContactSendingFormNode.getOrganisationTemplate(canEdit);
                break
            case ContactTypes.PHONE:
                newContact = ContactSendingFormNode.getPhoneTemplate(canEdit);
                break
            case ContactTypes.URL:
                newContact = ContactSendingFormNode.getUrlTemplate(canEdit);
                break
        }

        if (newContact !== undefined) {
            const contactList = this.contactInfo.controls[contact] as FormArray;
            contactList.push(newContact);
            this.contactInfoRawData = cloneDeep(this.contactInfo.getRawValue());
        }
    }

    deleteTemplate(_: DeleteContact) {
        this.contactInfoRawData = cloneDeep(this.contactInfo.getRawValue());
    }

    sendContact() {
        const rawValue = this.contactInfo.getRawValue();
        const contact: Contact = {
            contentType: 'contact',
            addresses: rawValue.addresses,
            birthday: rawValue.birthdays[0]?.birthday,
            emails: rawValue.emails,
            phones: rawValue.phones,
            urls: rawValue.urls,
            org: rawValue.org[0],
            name: {
                firstName: rawValue.firstName,
                lastName: rawValue.lastName,
                formattedName: rawValue.formattedName
            }
        }
        this.send.emit(contact)
    }
}
